module.exports = __webpack_public_path__ + "static/media/sem-imagem.18ce6afa.svg";